<template>
	<div>

		<breadcrumbs />

		<loading :active.sync="loading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.bet_logs }}
							</h6>
							<div class="element-box-tp">

								<table class="table table-bordered table-lg table-v2 table-striped">
									<thead>
									<tr>
										<th>#</th>
                    <th>Ext Id</th>
										<th>Market</th>
										<th>Special Value</th>
										<th>Outcome</th>
										<th>Created At</th>
										<th>Match Status</th>
										<th>Outcome Status</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="log in logs">
										<td class="text-right">
											{{ log.id }}
										</td>
                    <td class="text-danger">{{ log.odd.type.extended_id }}</td>
										<td class="text-danger">{{ log.odd.type.name }}</td>
										<td>{{ log.odd.special_value }}</td>
										<td>{{ log.odd.outcome }}</td>
										<td>{{ log.created_at | moment('YYYY D MMM ddd HH:mm:ss', session.timezone) }}</td>
										<td class="text-center">{{ log.match_result }}</td>
										<td class="text-center text-primary">{{ log.result }}</td>
										<td class="text-center">
											<div class="status-pill green" data-title="Complete" data-toggle="tooltip" data-original-title="" title=""></div>
										</td>
										<td class="row-actions">
											<a href="javascipt:;" @click="openDetail(JSON.parse(log.data))">
												<i class="os-icon os-icon-ui-49"></i>
											</a>
											<a href="javascipt:;" @click="openDetail(JSON.parse(log.data))">
												<i class="os-icon os-icon-ui-49"></i>
											</a>
										</td>
									</tr>
									</tbody>
								</table>

								<paginate v-if="pagination"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
START - Sidebar
-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
							<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">

						</b-collapse>
					</div>
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="detailModal">
			<vue-json-pretty class="alert text-left"
					:path="'res'"
					:data="jsonDetail"
					@click="handleClick">
			</vue-json-pretty>
		</sweet-modal>
	</div>
</template>

<script>
    export default {
        name: 'betLogs',
        data () {
            return {
                t: this.$root.t,
	            logs: null,
	            loading: false,
	            session: window.session,
                pagination: null,
	            jsonDetail: null
            }
        },
	    mounted () {
            this.fetchLogs()
	    },
	    methods: {
            openDetail(json){
                this.jsonDetail = json;
                this.$refs.detailModal.open()
            },
			fetchLogs(){
			    this.loading = true;
			    this.pagination = null;
                this.$http.get(api+'api/v1/bet/logs?sort=l.createdAt', {params: this.$route.query}).then(response => {

                    this.loading = false;
                    this.logs = response.body.logs;
                    this.pagination = response.body.pagination;
                }, response => {
                    this.loading = false;
                })
			}
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/logs/betLogs.vue